import angular from 'angular';
import 'angular-i18n/he-il';
import uiRouter from 'angular-ui-router';
import 'jquery';
import '../vendors/inspinia/js/bootstrap/bootstrap.min.js';

import appConfig from './app.config';
import Common from './common/common';
import Components from './components/components';
import Directives from './directives/directives';
import Services from './services/services';
import Filters from './filters/filters';
import AppComponent from './app.component';

angular.module('app', [
  uiRouter,
  Common,
  Components,
  Directives,
  Services,
  Filters
])
  .config(appConfig)
  .component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js